import React from 'react';

export const GiphyIcon: React.FC = () => (
  <svg width='68' height='24' viewBox='0 0 68 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0 4C0 1.79086 1.79086 0 4 0H64C66.2091 0 68 1.79086 68 4V20C68 22.2091 66.2091 24 64 24H4C1.79086 24 0 22.2091 0 20V4Z'
      fill='var(--primary-accent)'
    />
    <path
      d='M13.3333 6.66663H16.6666L14.6666 11.3333H17.3333L12 18.6666L13.3333 13.3333H10.6666L13.3333 6.66663Z'
      fill='white'
    />
    <path
      d='M28.7074 10.0597H30.3182C30.0497 8.34659 28.5668 7.15341 26.6364 7.15341C24.3523 7.15341 22.6392 8.83239 22.6392 11.6449C22.6392 14.4062 24.2756 16.1193 26.6832 16.1193C28.8438 16.1193 30.3906 14.7301 30.3906 12.4801V11.4318H26.8494V12.6676H28.8608C28.8352 13.9119 28.0043 14.7003 26.6918 14.7003C25.2301 14.7003 24.2287 13.6051 24.2287 11.6278C24.2287 9.66335 25.2472 8.57244 26.6577 8.57244C27.7102 8.57244 28.4261 9.13494 28.7074 10.0597ZM33.5004 7.27273H31.9194V16H33.5004V7.27273ZM35.2124 16H36.7933V13.0511H38.4638C40.4794 13.0511 41.5618 11.8409 41.5618 10.1619C41.5618 8.49574 40.4922 7.27273 38.4851 7.27273H35.2124V16ZM36.7933 11.7514V8.59375H38.2422C39.4268 8.59375 39.951 9.23295 39.951 10.1619C39.951 11.0909 39.4268 11.7514 38.2507 11.7514H36.7933ZM42.935 16H44.516V12.2926H48.56V16H50.1452V7.27273H48.56V10.9673H44.516V7.27273H42.935V16ZM51.2681 7.27273L54.4428 12.7443V16H56.0195V12.7443L59.1942 7.27273H57.4087L55.2738 11.1335H55.1886L53.0536 7.27273H51.2681Z'
      fill='white'
    />
  </svg>
);
